import React from 'react';

export default class PendingTag extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="PendingTag my-0">
				<span className="tag">{I18n.t('admin.pending_tag')}</span>
			</div>
		);
	}
}
